import React, { memo } from "react";
import { useHistory } from "react-router-dom";

const BackToPortfolioLink = () => {
  const history = useHistory();
  return (
    <button
      type="button"
      className="flex items-center gap-1 text-13 text-primary hover:underline mb-4"
      onClick={() => history.push("/sla-monitor")}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M9 11L5 7L9 3"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      All Properties
    </button>
  );
};

export default memo(BackToPortfolioLink);
